<template>
  <div id="invoice-page" :hidden="validatedAlan1">
    <b-row style="margin-top: 5px">
      <b-col>
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">İşlemler</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item
              @click="
                wholeStockActions = true;
                printStock();
              "
            >
              <span class="flex items-center">
                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>İndir/Yazdır</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </b-col>
    </b-row>
    <vx-card id="printMe2">
      <!-- INVOICE METADATA :hidden="invoiceValidate"-->
      <table style="width: 100%" class="border-collapse">
        <tr>
          <td class="p-2">
            <img class="" v-bind:src="logoUrl" alt="algolia-logo" />
          </td>
          <td style="padding: 10px; text-align: right">
            <h6>Sipariş Tarihi:</h6>
            <p>{{ getNow() }}</p>
            <h6 v-if="ROL == 'ADMIN'">Gönderim Tarihi: {{ setValuesTarih }}</h6>
          </td>
        </tr>
      </table>

      <br />
      <table style="width: 100%" class="border-collapse">
        <tr>
          <td style="padding: 10px">
            <h6>Teslimat Adresi | {{ musteriAd }}</h6>
            <p>{{ companyAdres }}</p>
          </td>
          <td style="padding: 10px; text-align: right"></td>
        </tr>
      </table>

      <br />
      <table style="border-top: 1px solid grey; width: 100%" class="border-collapse">
        <tr>
          <td>
            <table style="width: 100% !important; text-align: center">
              <tr>
                <th
                  sort-key="stokkodu"
                  style="text-align: center; border-bottom: 1px solid grey; padding: 3px"
                >
                  STOK KODU
                </th>

                <th
                  style="text-align: center; border-bottom: 1px solid grey; padding: 3px"
                >
                  BARKOD
                </th>
                <th
                  style="text-align: center; border-bottom: 1px solid grey; padding: 3px"
                >
                  ÜRÜN ADI
                </th>
                <th
                  style="text-align: center; border-bottom: 1px solid grey; padding: 3px"
                >
                  ÜRÜN FİYATI
                </th>
                <th
                  style="text-align: center; border-bottom: 1px solid grey; padding: 3px"
                >
                  KDV
                </th>
                <th
                  style="text-align: center; border-bottom: 1px solid grey; padding: 3px"
                >
                  ADET
                </th>
                <th
                  v-if="unit == true"
                  style="text-align: center; border-bottom: 1px solid grey; padding: 3px"
                >
                  BİRİM
                </th>
                <th
                  style="text-align: center; border-bottom: 1px solid grey; padding: 3px"
                >
                  TUTAR
                </th>
              </tr>

              <tr :key="indextr" v-for="(tr, indextr) in sipariseGoreUrunListesi">
                <td style="padding: 8px">
                  {{ tr.stockNo }}
                </td>

                <td style="padding: 8px">
                  {{ tr.barcode }}
                </td>
                <td style="padding: 8px">
                  {{ tr.stockName }}
                </td>
                <td style="padding: 8px">{{ tr.price }} TL</td>
                <td style="padding: 8px">{{ tr.vat }}</td>

                <td style="padding: 8px">{{ tr.quantity }} adet</td>
                <td style="padding: 8px"  v-if="unit == true">{{ tr.unit }} </td>

                <td style="padding: 8px">{{ tr.total }} TL</td>
              </tr>

              <tr>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>

                <td
                  style="
                    border-top: 1px solid grey;
                    border-left: 1px solid grey;
                    padding: 8px;
                  "
                >
                  Toplam:
                </td>
                <td
                  style="
                    border-top: 1px solid grey;
                    border-right: 1px solid grey;
                    padding: 8px;
                  "
                >
                  {{ totalPriceVat }} TL
                </td>
              </tr>
              <tr>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>

                <td style="border-left: 1px solid grey; padding: 8px">KDV Tutar:</td>
                <td style="border-right: 1px solid grey; padding: 8px">
                  {{ totalVat }} TL
                </td>
              </tr>
              <tr>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>

                <td style="border-left: 1px solid grey; padding: 8px">İskonto:</td>
                <td style="border-right: 1px solid grey; padding: 8px">
                  {{ totalIskonto }} TL
                </td>
              </tr>
              <tr>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>
                <td style="padding: 8px"></td>

                <td
                  style="
                    font-weight: bold;
                    border-bottom: 1px solid grey;
                    border-left: 1px solid grey;
                    padding: 8px;
                  "
                >
                  Toplam Tutar:
                </td>
                <td
                  style="
                    font-weight: bold;
                    border-bottom: 1px solid grey;
                    border-right: 1px solid grey;
                    padding: 8px;
                  "
                >
                  {{ totalPrice.toFixed(2) }} TL
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <br />
      </table>

      <br />
      <table style="width: 100%" class="border-collapse">
        <tr v-if="ROL == 'ADMIN'">
          <td class="p-2" style="text-align: center; font-size: 18px">
            <h6>
              Siparişiniz onaylanmıştır. {{ setValuesTarih }} tarihinde gönderilecektir.
            </h6>
          </td>
        </tr>
        <tr v-else>
          <td class="p-2" style="text-align: center; font-size: 18px">
            <h6>Siparişiniz başarıyla oluşturuldu.</h6>
          </td>
        </tr>
      </table>

      <br />

      <!-- INVOICE FOOTER -->
    </vx-card>
  </div>
</template>
<script>
//import { defineComponent } from "@vue/composition-api";
import Store from "../../store/store";
import state from "../../store/state";
import userJson from "../../../public/user.json";
import moment from "moment";
export default {
  props: [],
  name: "SiparisDetayButton",
  //[ pazaryerData=[], "orderNumber", "invoiceFirstName", "invoiceLastName", "shipFullName"],
  data() {
    return {
      unit: userJson.unit,

      totalIskonto: 0.0,
      totalPrice: 0.0,
      totalVat: 0.0,
      totalPriceVat: 0.0,
      gonderimTarihi: "",
      varyantlimi: userJson.varyant,
      logoUrl: "",
      company: "",
      companyAdres: "",
      sipariseGoreUrunListesi: [],
      invoiceValidate: true,
      degerKontrol: "",
      ROL: Store.state.ROL,
      validatedAlan1: true,
    };
  },

  methods: {
    printStock() {
      setTimeout(this.yazdirBekle, 1000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMe2");
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    getNow: function () {
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      const year = today.getFullYear();
      const output = day + "." + month + "." + year;

      return output;
    },
    setValuesCari(item) {
      if (typeof item == "undefined")
        this.sipariseGoreUrunListesi = this.$store.state.eCommerce.cartItems;
      else this.sipariseGoreUrunListesi = item;

      try {
        let totalPrc = 0.0;
        let totalVat = 0.0;
        if (this.cartItems.length > 0) {
          this.cartItems.forEach((value, index) => {
            totalPrc += value.total;
            totalVat += value.vatTotal;
          });
          let iskontoRate = this.cartItems.discount;
          let iskontoRateHesaplanan = (totalPrc * iskontoRate) / 100;
          let iskontoValidate = true;
          this.totalVat = totalVat;
          this.totalPriceVat = totalPrc;
          this.totalIskonto = iskontoRateHesaplanan;
          this.totalPrice = totalPrc + totalVat - iskontoRateHesaplanan;
          if (typeof this.totalIskonto == "undefined")
            this.iskontoRate = this.cartItems.discount;
        }
      } catch (error) {
        console.log(error);
      }
    },

    adresList() {
      let args = {};
      var musteriID = state.eCommerce.secilenGonderimMusteriIdsi;
      if (state.eCommerce.secilenGonderimMusteriIdsi == "")
        musteriID = Store.state.UserId;
      args = {
        token: state.tokenId,
        cariKod: musteriID,
        adresId: Store.state.eCommerce.secilenAdresId,
      };
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      soap.createClient(url, function (err, client) {
        client.B2B_AdresBilgisi(args, function (err, result) {
          try {
            vm.veriler = JSON.parse(result.B2B_AdresBilgisiResult);
            vm.companyAdres = vm.veriler[0].Address;
          } catch (error) {}
        });
      });
    },
  },
  computed: {
    musteriAd() {
      return Store.state.eCommerce.secilenGonderimMusterisi;
    },
    setValuesTarih() {
      return Store.state.eCommerce.secilenGonderimTarihi;
    },

    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse();
    },
  },
  watch: {
    cartItems(val) { 
      this.sipariseGoreUrunListesi = val;
      let totalPrc = 0.0;
      let totalVat = 0.0;
      val.forEach((value, index) => {
        totalPrc += value.total;
        totalVat += value.vatTotal;
      });
      let iskontoRate = val[0].discount;
      let iskontoRateHesaplanan = (totalPrc * iskontoRate) / 100;
      let iskontoValidate = true;
      this.totalVat = totalVat;
      this.totalPriceVat = totalPrc;
      this.totalIskonto = iskontoRateHesaplanan;
      this.totalPrice = totalPrc + totalVat - iskontoRateHesaplanan;
      return val;
    },
  },
  created() {
    if (this.ROL == "ADMIN") this.invoiceValidate = false;
    this.company = Store.state.eCommerce.secilenGonderimMusterisi;
    this.logoUrl = Store.state.logoUrl;
    this.validatedAlan1 = Store.state.ROL == "ADMIN" ? false : true;
    /*
    this.degerKontrol = Store.state.eCommerce.adminSepetKontrol;

    this.sipariseGoreUrunListesi = this.$store.state.eCommerce.cartItems;
    if (this.degerKontrol == "false") {
      this.companyAdres = Store.state.adres;
      this.company = Store.state.firmaAdi;
    } else {
      this.companyAdres = Store.state.eCommerce.secilenAdres;
      this.company = Store.state.eCommerce.secilenGonderimMusterisi;
    }
    this.gonderimTarihi = Store.state.eCommerce.secilenGonderimTarihi;*/
    //  this.adresList();
  },
  mounted() {
    this.$emit("setAppClasses", "invoice-page");
  },
  // mounted(){this.siparisDetay()}
};
</script>
